import React, { useEffect, useState } from "react";
import "./Loading.css";

function Loading({ onComplete }) {
  const [loading, setLoading] = useState(true);
  const [boxOpen, setBoxOpen] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const openTimer = setTimeout(() => {
      setBoxOpen(true);
    }, 450);

    const completeTimer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setLoading(false);
        if (onComplete) onComplete();
      }, 800);
    }, 3200);

    return () => {
      clearTimeout(openTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  if (!loading) return null;

  return (
    <div className={`loading-screen ${fadeOut ? "fade-out" : ""}`}>
      <div className="loading-background">
        <div className="loading-overlay"></div>
      </div>

      <div className={`loading-content ${boxOpen ? "box-open" : ""}`}>
        <div className="loader-gift" aria-label="Opening gift box">
          <div className="loader-gift__glow"></div>
          <div className="loader-confetti loader-confetti--one"></div>
          <div className="loader-confetti loader-confetti--two"></div>
          <div className="loader-confetti loader-confetti--three"></div>
          <div className="loader-confetti loader-confetti--four"></div>
          <div className="loader-gift__lid">
            <span className="loader-gift__bow loader-gift__bow--left"></span>
            <span className="loader-gift__bow loader-gift__bow--right"></span>
          </div>
          <div className="loader-gift__box">
            <span className="loader-gift__ribbon loader-gift__ribbon--vertical"></span>
            <span className="loader-gift__ribbon loader-gift__ribbon--horizontal"></span>
          </div>
        </div>

        <p className="loading-message">Unboxing something special...</p>

        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
      </div>
    </div>
  );
}

export default Loading;
